import React from 'react';
import * as Sentry from '@sentry/react';

const FallbackComponent = () => {
  return <div>An error has occurred</div>;
};

export const ErrorBoundary = ({ children }: { children: JSX.Element }) => {
  return <Sentry.ErrorBoundary fallback={FallbackComponent}>{children}</Sentry.ErrorBoundary>;
};
